import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  connectedUsersRequest,
  connectedUsersSuccess,
  connectedUsersFailure,
} from '../reducers/connectedUsers';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/`;

function* connectedUsersFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}${userId}/team/users`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerConnectedUsersSaga() {
  try {
    const response = yield call(connectedUsersFunctionAxios);

    const responseFromConnectedUsers = response.data.data;

    if (response.status === 201) {
      yield put(connectedUsersSuccess(responseFromConnectedUsers));
    }

    if (response.status === 200) {
      yield put(connectedUsersSuccess(responseFromConnectedUsers));
    }
    if (response.status === 500) {
      yield put(connectedUsersFailure(response.statusText));
    }
  } catch (error) {
    yield put(connectedUsersFailure(error));
  }
}

export function* watcherConnectedUsersSaga() {
  yield takeLatest(connectedUsersRequest().type, workerConnectedUsersSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/get_connectedUsers.js